import React, { useEffect, useState } from "react";
import SapakimHead from "./SapakimHead";
import { useParams, useNavigate } from "react-router-dom";
import { collection, query, where, getCountFromServer, getDocs } from "firebase/firestore";
import { db } from "../Components/Firebase";
import Loading from "../Components/Loading";
import '../Styles/Sapakim/SViewCustomers.css';

function SViewCustomers() {
  const { UID } = useParams();
  const [totalCustomers, setTotalCustomers] = useState(0);
  const [customersList, setCustomersList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");
  const nav = useNavigate();

  useEffect(() => {
    const fetchCustomersData = async () => {
      try {
        const customersQuery = query(collection(db, "Customers"), where("SapakId", "==", UID));

        const snapshot = await getCountFromServer(customersQuery);
        setTotalCustomers(snapshot.data().count);

        const customersSnap = await getDocs(customersQuery);
        const customers = customersSnap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setCustomersList(customers);
      } catch (error) {
        console.error("שגיאה בקבלת נתוני הלקוחות:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchCustomersData();
  }, [UID]);

  const filteredCustomers = customersList.filter(customer =>
    customer.Name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
    customer.PhoneNumber?.includes(searchTerm)
  );

  return (
    <React.Fragment>
      <SapakimHead />

      <div className="SViewCustomers-Functions" dir="rtl">
        {loading ? (
          <Loading />
        ) : (
          <>
            <h2>סה"כ: {totalCustomers}</h2>
            <input
              type="text"
              placeholder="חפש לפי שם או טלפון..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="customer-search-input"
            />
            <button onClick={() => { nav(`/SapakimHome/${UID}/SViewCustomers/SAddNewCustomer`) }}>הוסף לקוח חדש</button>
          </>
        )}
      </div>

      <div className="SViewAllCustomers" dir="rtl">
        {filteredCustomers.length > 0 ? (
          filteredCustomers.map(customer => (
            <div className="sapak-card" key={customer.id}>
              <h3>{customer.Name || "לא צויין"}</h3>
              <p><strong>טלפון:</strong> {customer.PhoneNumber || "לא צויין"}</p>
              <p><strong>מיקום:</strong> {customer.Location || "לא צויין"}</p>
              <button onClick={() => {nav(`/SapakimHome/${UID}/SViewCustomers/${customer.id}`)}}>פרטים</button>
            </div>
          ))
        ) : (
          <p>לא נמצאו לקוחות תואמים</p>
        )}
      </div>

    </React.Fragment>
  );
}

export default SViewCustomers;
